import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import {
  Autocomplete,
  Button,
  Typography,
  Grid,
  Tab,
  Tabs,
  TextField,
  DialogActions,
  ButtonGroup,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import React, { Fragment, useEffect, useState } from "react";

import { getDocumentoVariables } from "../../../../../containers/smartForms/components/helper";
import { language } from "../../../../../language";
import Provider from "../../../../../Provider";
import {
  escape,
  getUniqueDocumentServiceFields,
  unescape,
} from "../../../../../util/camundaPropertiesPanelUtils";
import GenericModal from "../../../../modal-closebtn/index";
import GenericSnackbar from "../../../../snackbar/generic-snackbar";

const FormPadding = styled("div")(({ theme }) => ({
  padding: "1% 1%",
}));

// TAB PANEL
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`wrapped-tabpanel-${index}`}
      aria-labelledby={`wrapped-tab-${index}`}
      {...other}
    >
      {children}
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

// TAB PROPERTIES
function TabProperties({
  jsonConfig,
  handleChangeConfigFields,
  handleChangeAutoCompleteConfigFields,
  handleChangeDocumentos,
  handleChangeAssinantes,
  handleChangeAutoCompleteAssinantes,
  addAssinantes,
  removeAssinantes,
  taskFields,
  businessObject,
}) {
  const title = jsonConfig?.title || "";
  const description = jsonConfig?.description || "";
  const authorName = jsonConfig?.authorName || "";
  const authorEmail = jsonConfig?.authorEmail || "";
  const authorDocument = jsonConfig?.authorDocument || "";
  const documents = jsonConfig?.documents || [];
  const signers = jsonConfig?.signers || "";

  let documentVariables = getDocumentoVariables(taskFields) || [];
  documentVariables = documentVariables.concat(
    getUniqueDocumentServiceFields(businessObject),
  );

  documentVariables = documentVariables
    .filter((value, index, self) => {
      return index === self.findIndex((obj) => obj.id === value.id);
    })
    .map((value) => value.id);

  const formFieldsVariables =
    taskFields?.filter(
      (taskField) =>
        !documentVariables.some((docItem) => docItem === taskField.id),
    ) || [];

  return (
    <>
      <Grid item size={12}>
        <Typography variant="h6">{language.signatureInformation}</Typography>
      </Grid>

      <Grid container item size={12} spacing={3} wrap="wrap">
        <Grid item size={12}>
          <Autocomplete
            value={title}
            onChange={(event, value) =>
              handleChangeAutoCompleteConfigFields(event, value, "title")
            }
            onInputChange={handleChangeConfigFields}
            selectOnFocus
            freeSolo
            id="title"
            name="title"
            options={formFieldsVariables}
            getOptionLabel={(formField) => {
              if (typeof formField === "string") {
                return formField;
              }
              return formField?.id || "";
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                name="title"
                required
                label={language.signatureTitle}
              />
            )}
          />
        </Grid>
        <Grid item size={12}>
          <Autocomplete
            value={description}
            onChange={(event, value) =>
              handleChangeAutoCompleteConfigFields(event, value, "description")
            }
            onInputChange={handleChangeConfigFields}
            selectOnFocus
            freeSolo
            id="description"
            name="description"
            options={formFieldsVariables}
            getOptionLabel={(formField) => {
              if (typeof formField === "string") {
                return formField;
              }
              return formField?.id || "";
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                name="description"
                required
                label={language.signatureDescription}
                minRows={3}
                multiline
              />
            )}
          />
        </Grid>
        <Grid item size={12}>
          <Autocomplete
            value={authorName}
            onChange={(event, value) =>
              handleChangeAutoCompleteConfigFields(event, value, "authorName")
            }
            onInputChange={handleChangeConfigFields}
            selectOnFocus
            freeSolo
            id="authorName"
            name="authorName"
            options={formFieldsVariables}
            getOptionLabel={(formField) => {
              if (typeof formField === "string") {
                return formField;
              }
              return formField?.id || "";
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                name="authorName"
                required
                label={language.signatureResponsibleName}
              />
            )}
          />
        </Grid>
        <Grid item size={12}>
          <Autocomplete
            value={authorEmail}
            onChange={(event, value) =>
              handleChangeAutoCompleteConfigFields(event, value, "authorEmail")
            }
            onInputChange={handleChangeConfigFields}
            selectOnFocus
            freeSolo
            id="authorEmail"
            name="authorEmail"
            options={formFieldsVariables}
            getOptionLabel={(formField) => {
              if (typeof formField === "string") {
                return formField;
              }
              return formField?.id || "";
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                name="authorEmail"
                required
                label={language.signatureResponsibleEmail}
              />
            )}
          />
        </Grid>
        <Grid item size={12}>
          <Autocomplete
            value={authorDocument}
            onChange={(event, value) =>
              handleChangeAutoCompleteConfigFields(
                event,
                value,
                "authorDocument",
              )
            }
            onInputChange={handleChangeConfigFields}
            selectOnFocus
            freeSolo
            id="authorDocument"
            name="authorDocument"
            options={formFieldsVariables}
            getOptionLabel={(formField) => {
              if (typeof formField === "string") {
                return formField;
              }
              return formField?.id || "";
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                name="authorDocument"
                required
                label={language.signatureResponsibleCpf}
              />
            )}
          />
        </Grid>
      </Grid>

      <Grid item size={12}>
        <Typography variant="h6">{language.documentsForSigning}</Typography>
      </Grid>

      <Grid item size={12}>
        <Autocomplete
          value={documents}
          onChange={(event, value, reason, detail) => {
            handleChangeDocumentos(event, value, detail);
          }}
          multiple
          id="document-list"
          options={documentVariables}
          getOptionLabel={(fileField) => fileField}
          filterSelectedOptions
          getOptionSelected={(option, value) => option === value}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              required
              label={language.signatureDocumentToBeSigned}
            />
          )}
        />
      </Grid>

      <Grid item size={12}>
        <Typography variant="h6">{language.signers}</Typography>
      </Grid>

      <Grid
        container
        item
        size={12}
        spacing={3}
        style={{ height: "56px" }}
        wrap="wrap"
      >
        {signers && signers.length > 0 ? (
          <>
            <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
              <Typography variant="body1" style={{ fontWeight: "410" }}>
                {language.signerName}*
              </Typography>
            </Grid>
            <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
              <Typography variant="body1" style={{ fontWeight: "410" }}>
                {language.signerEmail}*
              </Typography>
            </Grid>
            <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
              <Typography variant="body1" style={{ fontWeight: "410" }}>
                {language.signerCpf}*
              </Typography>
            </Grid>
            <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
              <Typography variant="body1" style={{ fontWeight: "410" }}>
                {language.addRemove}
              </Typography>
            </Grid>
            {signers.map((s, index) => {
              return (
                <Fragment key={`s${index}_${s.document}`}>
                  <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                    <Autocomplete
                      value={signers[index]?.signerName || ""}
                      onChange={(event, value) =>
                        handleChangeAutoCompleteAssinantes(
                          event,
                          value,
                          index,
                          "signerName",
                        )
                      }
                      onInputChange={(event) =>
                        handleChangeAssinantes(event, index, "signerName")
                      }
                      selectOnFocus
                      freeSolo
                      id={`s${index}_signerName"`}
                      name="signerName"
                      options={formFieldsVariables}
                      getOptionLabel={(formField) => {
                        if (typeof formField === "string") {
                          return formField;
                        }
                        return formField?.id || "";
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          name="signerName"
                          required
                          label={language.signerName}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                    <Autocomplete
                      value={signers[index]?.signerEmail || ""}
                      onChange={(event, value) =>
                        handleChangeAutoCompleteAssinantes(
                          event,
                          value,
                          index,
                          "signerEmail",
                        )
                      }
                      onInputChange={(event) =>
                        handleChangeAssinantes(event, index, "signerEmail")
                      }
                      selectOnFocus
                      freeSolo
                      id={`s${index}_signerEmail`}
                      name="signerEmail"
                      options={formFieldsVariables}
                      getOptionLabel={(formField) => {
                        if (typeof formField === "string") {
                          return formField;
                        }
                        return formField?.id || "";
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          name="signerEmail"
                          required
                          label={language.signerEmail}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                    <Autocomplete
                      value={signers[index]?.signerDocument || ""}
                      onChange={(event, value) =>
                        handleChangeAutoCompleteAssinantes(
                          event,
                          value,
                          index,
                          "signerDocument",
                        )
                      }
                      onInputChange={(event) =>
                        handleChangeAssinantes(event, index, "signerDocument")
                      }
                      selectOnFocus
                      freeSolo
                      id={`s${index}_signerDocument`}
                      name="signerDocument"
                      options={formFieldsVariables}
                      getOptionLabel={(formField) => {
                        if (typeof formField === "string") {
                          return formField;
                        }
                        return formField?.id || "";
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          name="signerDocument"
                          required
                          label={language.signerCpf}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                    <IconButton
                      size="small"
                      color="primary"
                      style={{
                        borderRadius: "8px",
                        border: "1px solid",
                      }}
                      onClick={(event) => removeAssinantes(event, index)}
                    >
                      <RemoveIcon />
                    </IconButton>
                  </Grid>
                </Fragment>
              );
            })}
          </>
        ) : (
          <Grid
            item
            size={12}
            justifyContent="center"
            alignItems="center"
            style={{ display: "flex" }}
          >
            <Typography variant="body1" style={{ fontWeight: "400" }}>
              {language.noMetadataSelected}
            </Typography>
          </Grid>
        )}
        <Grid item size={{ xs: 12, sm: 6, md: 9 }}></Grid>
        <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
          <IconButton
            size="small"
            color="primary"
            sx={{
              borderRadius: "8px",
              backgroundColor: "primary.main",
              color: "white",
              "&:hover": {
                backgroundColor: "primary.dark",
              },
            }}
            onClick={addAssinantes}
          >
            <AddIcon />
          </IconButton>
        </Grid>
      </Grid>
    </>
  );
}

// CUSTOMIZA AS AÇÔES DO MODAL
function OverrideModalActions(props) {
  const { handleSubmit, handleClose } = props;
  return (
    <DialogActions>
      <ButtonGroup>
        <Button
          variant="outlined"
          size="large"
          color="primary"
          onClick={handleClose}
        >
          {language.cancel}
        </Button>
        <Button
          variant="contained"
          size="large"
          color="primary"
          onClick={handleSubmit}
        >
          {language.save}
        </Button>
      </ButtonGroup>
    </DialogActions>
  );
}

// Componente

function ModelerIntegrarAssinatura({
  saveIntegrarAssinaturaConfig, // modeler
  businessObject,
  element,
  extensionElements,
  bpmnFactory,
  FormComponents,
  inputValues,
  theme, // tema
}) {
  const [jsonConfig, setJsonConfig] = useState({
    title: "",
    description: "",
    authorName: "",
    authorEmail: "",
    authorDocument: "",
    documents: [],
    signers: [],
  });

  const [state, setState] = useState({
    fullWidth: true,
    maxWidth: "lg",
    tabValue: 0,
    folderSelected: [],
    currentFolderSelected: false,
  });

  const [hasConfigError, setHasConfigError] = useState(false);

  const [open, setOpen] = useState(true);

  // EFFECT 1 - preenche o state com os dados do modeler
  useEffect(() => {
    if (inputValues) {
      setJsonConfig({
        title: inputValues?.title,
        description:
          inputValues?.description && unescape(inputValues.description),
        authorName: inputValues?.authorName,
        authorEmail: inputValues?.authorEmail,
        authorDocument: inputValues?.authorDocument,
        documents: inputValues?.documents,
        signers:
          inputValues?.signers?.map((s) => {
            return {
              signerName: s.name,
              signerEmail: s.email,
              signerDocument: s.document,
            };
          }) || [],
      });
    }
  }, [inputValues]);

  const handleClose = () => {
    setOpen(false);
  };

  //gerencia state das abas
  const handleChangeTab = (event, newValue) => {
    setState((prev) => ({
      ...prev,
      tabValue: newValue,
    }));
  };

  const validateConfig = (obj) => {
    const erros = [];

    if (!obj.title) {
      erros.push(language.signatureTitleRequired);
    }

    if (!obj.description) {
      erros.push(language.signatureDescriptionRequired);
    }

    if (!obj.authorName) {
      erros.push(language.signatureResponsibleNameRequired);
    }

    if (!obj.authorEmail) {
      erros.push(language.signatureResponsibleEmailRequired);
    }

    if (!obj.authorDocument) {
      erros.push(language.signatureResponsibleCpfRequired);
    }

    if (!obj.documents || obj.documents.length <= 0) {
      erros.push(language.signatureDocumentToBeSignedRequired);
    }

    if (!obj.signers || obj.signers.length <= 0) {
      erros.push(language.signersRequired);
    }

    if (obj.signers?.length) {
      if (
        obj.signers.filter((s) => !s.name || !s.email || !s.document).length > 0
      ) {
        erros.push(language.fillOrRemoveEmptySigners);
      }
    }

    return erros;
  };

  const handleSave = () => {
    const title = jsonConfig?.title;
    const description =
      jsonConfig?.description && escape(jsonConfig.description);
    const authorName = jsonConfig?.authorName;
    const authorEmail = jsonConfig?.authorEmail;
    const authorDocument = jsonConfig?.authorDocument;
    const documents = jsonConfig?.documents || [];
    let signers = jsonConfig?.signers || [];

    signers = signers.map((s) => {
      return {
        name: s.signerName,
        email: s.signerEmail,
        document: s.signerDocument,
      };
    });

    const inputObject = {
      title,
      description,
      authorName,
      authorEmail,
      authorDocument,
      documents,
      signers,
    };

    const erros = validateConfig(inputObject);

    if (erros.length > 0) {
      setHasConfigError(erros);
    } else {
      //salvando no modeler
      saveIntegrarAssinaturaConfig(
        businessObject,
        element,
        extensionElements,
        bpmnFactory,
        inputObject,
      );

      handleClose();
    }
  };

  const handleChangeConfigFields = (event) => {
    if (!event?.target) return;

    const { name, value } = event.target;
    setJsonConfig((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleChangeAutoCompleteConfigFields = (event, value, name) => {
    if (!event?.target) return;

    let newValue;
    if (typeof value === "string") {
      newValue = value;
    } else if (value?.id) {
      newValue = value.id;
    } else {
      newValue = value;
    }

    setJsonConfig((prev) => ({
      ...prev,
      [name]: newValue,
    }));
  };

  const handleChangeDocumentos = (event, newValue, selectedOption) => {
    const arrayValue = [];
    if (newValue && newValue.length > 0) {
      arrayValue.push(selectedOption.option);
    }

    setJsonConfig((prev) => ({
      ...prev,
      documents: arrayValue,
    }));
  };

  const handleChangeAssinantes = (event, index, name) => {
    if (!event?.target) return;

    const { value } = event.target;
    const signers = jsonConfig?.signers || [];

    signers[index] = {
      ...signers[index],
      [name]: value,
    };

    setJsonConfig((prev) => ({
      ...prev,
      signers,
    }));
  };

  const handleChangeAutoCompleteAssinantes = (event, value, index, name) => {
    if (!event?.target) return;

    const signers = jsonConfig?.signers || [];

    let newValue;
    if (typeof value === "string") {
      newValue = value;
    } else if (value?.id) {
      newValue = value.id;
    } else {
      newValue = value;
    }

    signers[index] = {
      ...signers[index],
      [name]: newValue,
    };

    setJsonConfig((prev) => ({
      ...prev,
      signers,
    }));
  };

  const addAssinantes = () => {
    const signers = jsonConfig?.signers || [];

    signers.push({
      signerName: "",
      signerEmail: "",
      signerDocument: "",
    });

    setJsonConfig((prev) => ({
      ...prev,
      signers,
    }));
  };

  const removeAssinantes = (event, index) => {
    const signers = jsonConfig?.signers || [];

    signers.splice(index, 1);

    setJsonConfig((prev) => ({
      ...prev,
      signers,
    }));
  };

  const { tabValue } = state;

  return (
    open && (
      <GenericModal
        title={language.configuration}
        handleClose={handleClose}
        size={state.maxWidth}
        bigHeight
        open={true}
        handleSubmit={handleSave}
        btnActionTitle={language.save}
        btnCancelTitle={language.cancel}
        overrideDialogActions={() =>
          OverrideModalActions({
            handleSubmit: handleSave,
            handleClose,
          })
        }
      >
        <Tabs
          value={tabValue}
          indicatorColor="secondary"
          textColor="secondary"
          onChange={handleChangeTab}
        >
          <Tab label={language.properties} />
          <Tab label={language.configuration} disabled />
          <Tab label={language.permissions} disabled />
        </Tabs>
        <FormPadding>
          <TabPanel value={tabValue} index={0}>
            <Grid container spacing={3}>
              <TabProperties
                businessObject={businessObject}
                taskFields={FormComponents}
                jsonConfig={jsonConfig}
                handleChangeConfigFields={handleChangeConfigFields}
                handleChangeAutoCompleteConfigFields={
                  handleChangeAutoCompleteConfigFields
                }
                handleChangeDocumentos={handleChangeDocumentos}
                handleChangeAssinantes={handleChangeAssinantes}
                handleChangeAutoCompleteAssinantes={
                  handleChangeAutoCompleteAssinantes
                }
                addAssinantes={addAssinantes}
                removeAssinantes={removeAssinantes}
              />
            </Grid>
          </TabPanel>
        </FormPadding>

        {hasConfigError && (
          <GenericSnackbar
            errorWithChildren={true}
            message={
              <div>
                {hasConfigError.map((err, index) => {
                  return <div key={`errorMessage_${index}`}>{err}</div>;
                })}
              </div>
            }
            handleClose={() => setHasConfigError(false)}
            duration={4000}
          />
        )}
      </GenericModal>
    )
  );
}

export default ModelerIntegrarAssinatura;
